import React, { useState } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import clsx from "clsx";
import { API } from "../../api/api";
import constants from "../../utils/contants";

const loginSchema = Yup.object().shape({
  email: Yup.string()
    .email("Please enter valid email.")
    .required("Please enter email."),
  password: Yup.string()
    .min(8, "Please enter minimum 8 characters.")
    .required("Please enter password."),
});

const initialValues = {
  email: "",
  password: "",
};

const LoginPage = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      setLoading(true);
      setSubmitting(true);
      API(
        "login-admin",
        "post",
        { email: values.email, password: values.password },
        ""
      )
        .then((res) => {
          setLoading(false);
          setStatus("");
          setSubmitting(false);
          console.log("res: ", res);
          localStorage.setItem(constants.TOKEN, res?.user?.token);
          navigate("/");
        })
        .catch((error) => {
          console.log("login error: ", error?.response?.data);
          if (error?.response?.data?.message)
            setStatus(error?.response?.data?.message);
          else setStatus("The login details are incorrect");

          setSubmitting(false);
          setLoading(false);
        });
    },
  });

  return (
    <div className="Auth-form-container">
      {/* <img src={logo} className="logo" alt="logo_image" /> */}

      <p className="text-white fw-bold fs-3 mt-3">Taxi Application</p>

      <form className="Auth-form" onSubmit={formik.handleSubmit}>
        <div className="Auth-form-content">
          {/* title */}
          <h3 className="Auth-form-title">Login</h3>

          {/* username field */}
          <div className="form-group mt-3">
            <label>Email</label>
            <input
              type="text"
              {...formik.getFieldProps("email")}
              className={clsx(
                "form-control bg-transparent",
                {
                  "is-invalid": formik.touched.email && formik.errors.email,
                },
                {
                  "is-valid": formik.touched.email && !formik.errors.email,
                }
              )}
              placeholder="Enter email"
            />
            {formik.touched.email && formik.errors.email && (
              <div className="fv-plugins-message-container text-danger">
                <span role="alert">{formik.errors.email}</span>
              </div>
            )}
          </div>

          {/* password field */}
          <div className="form-group mt-3">
            <label>Password</label>
            <input
              type="password"
              placeholder="Enter password"
              {...formik.getFieldProps("password")}
              className={clsx(
                "form-control bg-transparent",
                {
                  "is-invalid":
                    formik.touched.password && formik.errors.password,
                },
                {
                  "is-valid":
                    formik.touched.password && !formik.errors.password,
                }
              )}
            />
            {formik.touched.password && formik.errors.password && (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block text-danger">
                  <span role="alert">{formik.errors.password}</span>
                </div>
              </div>
            )}
          </div>

          {formik.status && (
            <div className="text-danger mt-1">{formik.status}</div>
          )}

          {/* submit button */}
          <div className="d-grid gap-2 mt-3">
            <button
              type="submit"
              id="kt_sign_in_submit"
              className="btn btn-primary btn_primary"
              disabled={formik.isSubmitting || !formik.isValid}
            >
              {!loading && <span className="indicator-label">Continue</span>}
              {loading && (
                <span
                  className="indicator-progress"
                  style={{ display: "block" }}
                >
                  Please wait...
                  <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                </span>
              )}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default LoginPage;
